import Vue from 'vue';

const handler = async (fetchName, params) => {
  try {
    const resultData = await fetchName(params);
    if (resultData.data) {
      // 获取到正常数据并返回
      if (resultData.data.code.toString() === '200' || resultData.data.code.toString() === '304') {
        return {
          code: 'success',
          data: resultData.data.data,
          pageLimit: resultData.data.pageLimit,
          text: resultData.data.text
        };
      } else {
        // 状态码异常
        Vue.prototype.toast.show(resultData.data ? resultData.data.text : '接口服务异常');
        return {
          code: 'no_data',
          text: resultData.data.text
        }
      }
    } else {
      Vue.prototype.toast.show(resultData.data.text || '网络异常');
      // 接口返回异常
      return {
        code: 'error',
        text: resultData.data.text
      }
    }
  } catch (e) {
    Vue.prototype.toast.show(e);
    // 请求失败
    return {
      code: 'fail'
    };
  }
};

export default handler;



// WEBPACK FOOTER //
// ./src/starcharge/mock/handler.js